import { render, staticRenderFns } from "./LandParcelMortgages.vue?vue&type=template&id=1f767b2a&scoped=true&"
import script from "./LandParcelMortgages.vue?vue&type=script&lang=js&"
export * from "./LandParcelMortgages.vue?vue&type=script&lang=js&"
import style0 from "./LandParcelMortgages.vue?vue&type=style&index=0&id=1f767b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f767b2a",
  null
  
)

export default component.exports